import React, { useState, useEffect } from 'react';

const CleaningTable = ({ uId }) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [pumpNumbers, setPumpNumbers] = useState([]);

    const itemsPerPage = 10;
    const [userD, setUserD] = useState(null);
    const [macId, setMachineId] = useState();
    const [macName, setMacName] = useState();
    useEffect(() => {
        getData();
    }, []);
    useEffect(() => {
        const userDataString = sessionStorage.getItem('userData');
        if (userDataString) {
            const userData = JSON.parse(userDataString);
            setUserD(userData);
            // Use userData as needed
        }
        // console.log(userDataString);
    }, []);
    useEffect(() => {
        setMachineId(userD ?.selectedMachineIds);
        setMacName(userD?.selectedName);
    }, [userD]);
    const getData = () => {
        const userData = JSON.parse(sessionStorage.getItem('userData'));
        if (!userData || !userData.id) {
        throw new Error('User ID not found in session storage');
        }
        const userId = userData.id;
        const macId = userData.selectedMachineIds;
        fetch(`/api/latestPumpNumbers/${userId}?macId=${macId}`, {
            method: "GET",
            credentials: "include",
        })
        .then(response => response.json())
        .then(data => {
            // console.log(data.latestPumpData, 'pumps data');
            const pumpData = data.latestPumpData || []; // fallback to empty array
            setPumpNumbers(pumpData);
            setTotalPages(Math.ceil(pumpData?.length / itemsPerPage));
        })
        .catch(error => console.error('Error fetching data:', error));
    };
    

    const handleClick = (type) => {
        if (type === 'prev') {
            setCurrentPage(currentPage === 1 ? 1 : currentPage - 1);
        } else if (type === 'next') {
            setCurrentPage(currentPage === totalPages ? totalPages : currentPage + 1);
        } else {
            setCurrentPage(type);
        }
    };

    const renderTableRows = () => {
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        const currentItems = pumpNumbers.slice(startIndex, endIndex);

        return currentItems
        // .sort((a, b) => a.pump_no - b.pump_no)
        .map((pump, index) => {
            // Parse the cl_date string into a Date object
            const clDate = new Date(pump.cl_date);
            // Format the clDate as per your requirement
            const formattedClDate = clDate.toISOString().replace('T', ' ').slice(0, -5);
            
            return (
                <tr key={index} className={`cl-ingre ${smallMedia ? "cl-ingre2" : ""}`}>
                    <td><div className="cell-content">{pump.pump_no}</div></td>
                    <td><div className='cell-content'>{pump.ingredient_name}</div></td>
                    <td><div className="cell-content">{formattedClDate}</div></td> {/* Display the formatted cl_date */}
                </tr>
            );
        });
    };


    const smallMedia = window.innerWidth <= 768;
useEffect(() => {
    if (macId) {
        getData();
    }
}, [macId]);
    return (
        <div className={`homeIngre ${smallMedia ? "homeIngre2" : ""}`}>
            <div className={`${smallMedia ? "stock-hh" : "stock-hh2"}`}>
                <div className={`${smallMedia ? "" : "custom-h"}`}>Cleaning</div>
            </div>
            <div className='tb2' style={{height: pumpNumbers?.length < 10 ? `${pumpNumbers?.length * 7+'%'}` : ''}}>
                <table className="customTable ingCl-tbl" style={{ borderCollapse: 'collapse', tableLayout: "fixed" }}>
                    <thead className="tb-head">
                        <tr className={`cl-ingre ${smallMedia ? "cl-ingre2" : ""}`}>
                            <th className='cell-content'>Pump No</th>
                            <th className='cell-content'>Ingredient</th>
                            <th className='cell-content'>Date Time</th>
                        </tr>
                    </thead>
                    <tbody>{renderTableRows()}</tbody>
                </table>
            </div>
            <div className='bottomIngre'>
                <div className='tb2-btm-lft'>
                    <div className={`st-show ${smallMedia ? "st-show2" : ""}`}>
                        <p className="onscreen">Showing {Math.min(((currentPage - 1) * itemsPerPage) + 1, pumpNumbers?.length)} to {Math.min(currentPage * itemsPerPage, pumpNumbers?.length)}</p>
                        <p className="total">(Total {pumpNumbers?.length} entries)</p>
                    </div>
                </div>
                <div className={`h-pagenation ${smallMedia ? "h-pagenation2" : ""}`}>
                    <button onClick={() => handleClick('prev')} disabled={currentPage === 1} className='constbtn'>Previous</button>
                    {/* <span className=" pbtn">{currentPage}</span> */}
                    {[...Array(totalPages)].map((_, index) => (
                    <button key={index} onClick={() => handleClick(index + 1)}
                    className={`pbtn ${currentPage === index + 1 && smallMedia ? "active12a2a " : currentPage === index + 1 ? "active12a2a" : ""}`}
                    >{index + 1}</button>
                    ))}
                    <button onClick={() => handleClick('next')} disabled={currentPage === totalPages} className='constbtn'>Next</button>
                </div>
            </div>
        </div>
    );
};

export default CleaningTable;
